import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center q-pa-md"
}
const _hoisted_2 = {
  key: 1,
  class: "pig-run-summary q-mt-sm"
}
const _hoisted_3 = { class: "summary-grid" }
const _hoisted_4 = { class: "summary-row" }
const _hoisted_5 = { class: "summary-value" }
const _hoisted_6 = { class: "summary-row" }
const _hoisted_7 = { class: "summary-value" }
const _hoisted_8 = { class: "summary-row" }
const _hoisted_9 = { class: "summary-value" }
const _hoisted_10 = { class: "summary-row" }
const _hoisted_11 = { class: "summary-value" }
const _hoisted_12 = { class: "summary-row" }
const _hoisted_13 = { class: "summary-value" }
const _hoisted_14 = { class: "summary-row" }
const _hoisted_15 = { class: "summary-value" }
const _hoisted_16 = { class: "summary-row" }
const _hoisted_17 = { class: "summary-value" }
const _hoisted_18 = { class: "summary-row" }
const _hoisted_19 = { class: "summary-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_spinner, {
          color: "blue-brand",
          size: "2em"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-caption text-grey-7 q-mt-xs" }, "Loading summary…", -1))
      ]))
    : (_ctx.runData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "summary-label" }, "Pig Run", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.runData.name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "summary-label" }, "Pipeline", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.runData.pipelineSectionName || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "summary-label" }, "Launch", -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.runData.launchDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "summary-label" }, "Receive", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.runData.receiveDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "summary-label" }, "Markers", -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.markerCount), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "summary-label" }, "Devices", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.deviceCount), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "summary-label" }, "Passages", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.runData.passageCount ?? 0), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "summary-label" }, "Verified", -1)),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.runData.verifiedPassageCount ?? 0), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}